<template>
  <div class="bottomDialog">
    <div class="mask" @click="close"></div>
    <div class="content">
      <slot name="dialog-detail" v-if="slotFlag"></slot>
      <div class="flex box" v-else>
        <div class="title">APP已上线，下载APP直接领取！！！</div>
        <img class="dialog-img" src="" alt="" />
        <div class="tips">加油！距离限量punkcat仅有一步！</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    img: {
      type: String,
    },
    tips: {
      type: String,
    },
        slotFlag: {
      type: Boolean,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style lang="less" scoped>
@import "./bottomDialog.less";
</style>
